import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';
import Navbar from '../components/Navbar';
import TopInfoBar from '../components/TopInfoBar';
import BookingSidebar from '../components/BookingSidebar';
import Footer from '../components/Footer';

function TermsOfService() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const handleOpenBooking = () => setIsBookingOpen(true);
  const handleCloseBooking = () => setIsBookingOpen(false);

  return (
    <div className="terms-of-service-page">
      <TopInfoBar />
      <Navbar onBookNowClick={handleOpenBooking} />
      <section className="terms-of-service-section">
        <div className="terms-of-service-container">
          <div className="terms-of-service-content">
            <h1 className="terms-of-service-title">Terms of Service</h1>
            <p className="terms-of-service-intro">
              Welcome to Hacienda Del Sol Resort ("we," "our," or "us"). By using our website and submitting a quote request, you agree to the following terms:
            </p>

            <div className="terms-section">
              <h2 className="terms-section-title">1. Use of Our Website</h2>
              <p className="terms-section-text">
                You agree to use our website for lawful purposes only. You will not:
              </p>
              <ul className="terms-list">
                <li>Submit false or misleading information</li>
                <li>Attempt to interfere with the website's operation</li>
                <li>Use the website for any unauthorized commercial purpose</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">2. Quote Requests</h2>
              <ul className="terms-list">
                <li>Submitting a quote request does not create a binding contract.</li>
                <li>All quotes provided are estimates and subject to availability and final confirmation.</li>
                <li>We reserve the right to approve or decline any request at our discretion.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">3. Intellectual Property</h2>
              <p className="terms-section-text">
                All content on this website, including images, text, logos, and designs, is the property of Hacienda Del Sol Resort and protected by copyright. You may not copy, distribute, or use content without our written permission.
              </p>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">4. Limitation of Liability</h2>
              <ul className="terms-list">
                <li>Hacienda Del Sol Resort is not responsible for any damages, losses, or inconvenience resulting from your use of the website or reliance on quote estimates.</li>
                <li>We make no guarantees about the accuracy, completeness, or reliability of information on our website.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">5. Privacy</h2>
              <p className="terms-section-text">
                Your personal information is handled in accordance with our{' '}
                <Link to="/privacy-notice" className="terms-link">Privacy Policy</Link>.
              </p>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">6. Changes to Terms</h2>
              <p className="terms-section-text">
                We may update these Terms of Service at any time. Updated terms will be posted on this page with the revision date. Continued use of our website constitutes acceptance of the updated terms.
              </p>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">7. Governing Law</h2>
              <p className="terms-section-text">
                These Terms of Service are governed by the laws of [Insert State/Country], without regard to its conflict of law principles.
              </p>
            </div>

            <div className="terms-section">
              <h2 className="terms-section-title">Contact Us</h2>
              <p className="terms-section-text">
                If you have questions about these terms, please contact us:
              </p>
              <ul className="terms-list">
                <li>Phone: [956] 459-9800</li>
              </ul>
            </div>

            <div className="terms-section">
              <p className="terms-effective-date">
                Effective Date: [01/08/2026]
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer onBookNowClick={handleOpenBooking} />
      <BookingSidebar isOpen={isBookingOpen} onClose={handleCloseBooking} />
    </div>
  );
}

export default TermsOfService;
